import { GET_CLIENTS_LIST } from '../actions/types';
import isEmpty from '../validation/is-empty';

const initialState = {
  list: []
}

export default function(state = initialState, action ) {
//   console.log(action.payload);
    switch(action.type) {
        case GET_CLIENTS_LIST:
            return {
                ...state,
                list: action.payload
            }
        default:
            return state;
    }
}
